import { render, staticRenderFns } from "./list-agents.vue?vue&type=template&id=877828bc"
import script from "./list-agents.vue?vue&type=script&lang=js"
export * from "./list-agents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports